import { SelectedFilterInterface } from "storyblok/components";

//used by VacancyAlert.tsx, EmptyCard.tsx
//requires the full options useState and the clicked filter key and value
//returns the new options state object

// takes the clicked filter tuple and filters it out of renderOptions and selectedFilterOptions.
export default function filterTupleFilterer(
    filterKey: keyof SelectedFilterInterface,
    filterValue: string | number,
    fullFilterOptionsState: SelectedFilterInterface
) {
    //if an array, take the key and filter the value out
    if (
        fullFilterOptionsState[`${filterKey}`] &&
        Array.isArray(fullFilterOptionsState[`${filterKey}`])
    ) {
        const newArray = [];

        for (const element of fullFilterOptionsState[
            `${filterKey}`
        ] as Array<string>) {
            if (element !== filterValue) {
                newArray.push(element);
            }
        }
        return { ...fullFilterOptionsState, [`${filterKey}`]: newArray };
    }

    //if  not an array, the only other filter categories are min and max hours so just delete the key from state
    const deleteFilterKey = { ...fullFilterOptionsState };
    delete deleteFilterKey[`${filterKey}`];
    return deleteFilterKey;
}
